import { Box, LinearProgress, Typography } from "@mui/material";
import classes from './ModalLoading.module.scss';
import { ModalLoadingProps } from "../../interfaces/props/ModalLoadingProps";

const ModalLoading = ({ message, infoMessage }: ModalLoadingProps) => {
  return <Box className={`empty-modal ${classes.box} d-flex flex-column justify-content-center`}>
    <Typography className='h3 mb-3' align='center'>
      {message}
    </Typography>
    <Typography className={`${classes['info-text']} mb-2text-subtitle px-2`} align='center' gutterBottom>
      {infoMessage}
    </Typography>
    <LinearProgress className={classes.progress} color='success' />
  </Box>
};

export default ModalLoading;